<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title1"></a><div class="title-frontMatter">Publisher’s Preface</div>
<div class="p-indent">The essays in this little volume, published here for the first time in book form, were written by Bertrand Russell during the second World War.</div>
<div class="p-indent">In those years the author was teaching philosophy at American universities, exercising a growing influence on America’s student population.</div>
<div class="p-indent">The essays assembled here are fundamentally concerned with “the art of reckoning” in the fields of mathematics, logic and philosophy.</div>
<div class="p-indent">The simplicity of Russell’s exposition is astonishing, as is his ability to get to the core of the great philosophical issues and to skillfully probe the depth of philosophical analysis.</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780806537351_fm01.vue?363a163c